export default __webpack_public_path__ + "static/ali-spittel-27e772bdbbc275768964d28980ce423b.png";